import api, { baseApiService } from "shared/api";
import useSWR from "swr";

export const cardRequestFetcher = ([url, requestNumber, userRole]) =>
  api
    .post(url, {
      application_number: requestNumber,
      user_role: userRole,
    })
    .then((res) => res.data.data);

export function useCardRequest(requestNumber, userRole) {
  return useSWR(
    [baseApiService.ENDPOINTS.request.card.request, requestNumber, userRole],
    cardRequestFetcher,
    {
      revalidateOnFocus: false,
    }
  );
}
